export default {"src":"/_next/static/media/icon-travel-spend-management.84df8678.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};